import PropTypes from "prop-types";
import { styled, InputBase, Grid, Typography, Box } from "@mui/material";
import React from "react";
import { PALETTE } from "../../Theme/Palette";

const DesignedInput = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    "&::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
    },
    "&::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
    },
    "&[type=number]": {
      MozAppearance: "textfield",
    },
    position: "relative",
    color: PALETTE.third,
    textAlign: "right",
    borderStyle: "none",
    borderRadius: "0.5rem",
    fontSize: 14,
    fontWeight: "bold",
    padding: "0.6rem 0.7rem",
    border: "1px solid " + PALETTE.fourth,
    "&:disabled , &.Mui-disabled": {
      WebkitTextFillColor: PALETTE.sixth,
      color: PALETTE.sixth,
      backgroundColor: PALETTE.fifth,
      border: "1px solid transparent",
    },
  },
}));

function BaseInput({
  width,
  placeholder,
  name = "",
  isSignIn,
  label,
  type,
  isAddress,
  isDeactivate,
  value,
  pass,
  maxLength,
  aligning,
  onChange = () => {},
  ...props
}) {
  function validateNumber(event) {
    var e = event || window.event;
    var key = e.keyCode || e.which;

    if (
      (!e.shiftKey &&
        !e.altKey &&
        !e.ctrlKey &&
        // numbers
        key >= 48 &&
        key <= 57) ||
      // Numeric keypad
      (key >= 96 && key <= 105) ||
      // Backspace and Tab and Enter
      key === 8 ||
      key === 9 ||
      key === 13 ||
      // Home and End
      key === 35 ||
      key === 36 ||
      // left and right arrows
      key === 37 ||
      key === 39 ||
      // Del and Ins
      key === 46 ||
      key === 45
    ) {
      // input is VALID
    } else {
      // input is INVALID
      e.returnValue = false;
      if (e.preventDefault) e.preventDefault();
    }
  }
  return (
    <>
      {isSignIn ? (
        <Grid
          container
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          my={0.5}
          width={width}
        >
          <DesignedInput
            placeholder={placeholder}
            fullWidth
            type={pass}
            value={value}
            name={name}
            onChange={onChange}
            inputProps={{ maxLength: maxLength }}
            sx={{
              background: PALETTE.primary,
            }}
            {...props}
          />
        </Grid>
      ) : (
        <Box
          display="flex"
          alignItems={"center"}
          justifyContent="flex-end"
          width={{
            xs: isAddress ? "100%" : "100%",
            sm: isAddress ? "610px" : "288px",
            md: isAddress ? "610px" : "288px",
          }}
          ml={{ xs: 0, sm: 4, md: 4 }}
        >
          <Grid
            container
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            my={0.5}
            width={{
              xs: isAddress ? "100%" : "65%",
              sm: { width },
              md: { width },
            }}
            mr={{ xs: isAddress ? 5 : 0, sm: isAddress ? 2 : 0 }}
          >
            {type === "tel" ? (
              <DesignedInput
                placeholder={placeholder}
                type={type}
                name={name}
                fullWidth
                value={value}
                inputProps={{ maxLength: maxLength }}
                onChange={onChange}
                onKeyDown={(e) => validateNumber(e)}
                {...props}
              />
            ) : (
              <DesignedInput
                placeholder={placeholder}
                type={type}
                name={name}
                fullWidth
                value={value}
                onChange={onChange}
                inputProps={{ maxLength: maxLength }}
                {...props}
              />
            )}
          </Grid>
          <Typography variant="h2" textAlign="right" width="35%">
            {label}
          </Typography>
        </Box>
      )}
    </>
  );
}

BaseInput.propTypes = {
  width: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  isSignIn: PropTypes.bool,
  label: PropTypes.string,
  type: PropTypes.string,
  isAddress: PropTypes.bool,
  isDeactivate: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
};

export default BaseInput;
